import { application } from "./application";

import AttachmentController from "./attachment_controller";
import ClipboardController from "./clipboard_controller";
import DraggableController from "./draggable_controller";
import ModalController from "./modal_controller";
import OccurrenceEditController from "./occurrence_edit_controller";
import OccurrenceShowController from "./occurrence_show_controller";
import ResetFilterController from "./reset_filter_controller";
import TabController from "./tab_controller";

application.register("attachment", AttachmentController);
application.register("clipboard", ClipboardController);
application.register("draggable", DraggableController);
application.register("modal", ModalController);
application.register("occurrence-edit", OccurrenceEditController);
application.register("occurrence-show", OccurrenceShowController);
application.register("reset-filter", ResetFilterController);
application.register("tab", TabController);
